/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { object, shape, string } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';
import normalizeAltCopy from '../../../../../helpers/normalizeAltCopy';

const styles = () => ({
    banner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '30px auto',
        padding: '30px 0',
        maxWidth: '1400px',
        '& > div': {
            margin: '0',
            width: '53%',
            paddingLeft: '3rem',
        },
        '& h3': {
            fontSize: '2em',
            margin: '0 ',
        },
        '& p': {
            fontSize: '1em',
            fontWeight: '700',
            lineHeight: '1.5em',
        },
        '& img': {
            maxHeight: '320px',
            maxWidth: '320px',
            width: '100%',
            borderRadius: '50%',
            border: 'solid 5px #fff',
        },
        '& a': {
            fontSize: '.8em',
            fontWeight: '700',
            margin: '0 0 0 10px',
        },
    },
    bannerMob: {
        flexDirection: 'column',
        padding: '30px 15px',
        '& h3': {
            display: 'block',
            fontSize: '1.8em',
            fontWeight: '700',
            margin: '24px auto 0',
        },
        '& img': {
            width: '80vw',
            height: '80vw',
        },
        '& p': {
            fontSize: '1.3em',
            lineHeight: '1.4em',
        },
        '& a': {
            display: 'block',
            margin: '10px 0 10px 5px',
            width: '100%',
            fontSize: '1em',
        },
    },
});

const Banner = ({
    data, classes,
}) => {
    const getFont = () => {
        const style = {};
        if (data.heading_font?.length) style.fontFamily = data.heading_font?.split(':')[1].replace(';', '');
        return style;
    };

    const normalizeAltCopyDescription = normalizeAltCopy(data?.image_main?.description || data?.image_main?.title);
    return (
        <DesktopMobile
            desktop={() => (
                <div className={classes.banner} style={{ background: `url(${data.image_bg.url})`, color: data.font_color.color }}>
                    <img src={data.image_main.url} alt={normalizeAltCopyDescription || 'Product Image'} />
                    <div><h3 style={getFont()}>{data.banner_heading}</h3>
                        <p>{data.copy}</p>
                        {data.link?.href && <Link to={data.link?.href} style={{ color: data.font_color.color }}>{data.link?.title}</Link>}
                    </div>
                </div>
            )}
            mobile={() => (
                <div className={`${classes.banner} ${classes.bannerMob}`} style={{ background: `url(${data.image_bg.url})`, color: data.font_color.color }}>
                    <img src={data.image_main.url} alt={normalizeAltCopyDescription || 'Product Image'} />
                    <h3 style={getFont()}>{data.banner_heading}</h3>
                    <p>{data.copy}</p>
                    {data.link?.href && <Link to={data.link?.href} style={{ color: data.font_color.color }}>{data.link?.title}</Link>}
                </div>
            )}
            breakpoint={767}
        />
    );
};

Banner.propTypes = {
    data: shape({
        banner_heading: string,
        heading_font: string,
        copy: string,
        image_main: shape({
            url: string,
            title: string,
        }),
        image_bg: shape({
            url: string,
            title: string,
        }),
        font_color: shape({
            color: string,
        }),
    }),
    classes: object.isRequired,
};
Banner.defaultProps = {
    data: {
        banner_heading: '',
        heading_font: 'Arial, Verdana, sans-serif',
        copy: '',
        image_main: {
            url: '',
            title: '',
        },
        image_bg: {
            url: '',
        },
        font_color: {
            color: '#FFF',
        },
    },
};
export default withStyles(styles)(Banner);
